export default function WhatIsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-foreground-950">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-foreground-800 text-background-100 uppercase tracking-wider mb-5">
              Getting Started
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 leading-tight">
              What Is{" "}
              <span className="text-primary-400">Pandabuy Spreadsheet</span>?
            </h2>
            <p className="mt-5 text-foreground-300 leading-relaxed text-sm md:text-base max-w-[520px]">
              A pandabuy spreadsheet is a curated collection of product listings used by buyers worldwide to discover trending items, streetwear, sneakers, and luxury alternatives. These spreadsheets compile the best finds from the community into one organized, easy-to-browse database.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: "ri-layout-grid-line", title: "Organized Spreadsheets", desc: "Every item categorized and searchable" },
                { icon: "ri-star-line", title: "Quality Rankings", desc: "Community-rated and verified listings" },
                { icon: "ri-scales-line", title: "Price Comparisons", desc: "Compare across multiple sources easily" },
                { icon: "ri-user-star-line", title: "Verified Picks", desc: "Handpicked by experienced community members" },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-3 p-4 rounded-xl bg-foreground-900/50 border border-foreground-800/50">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/20 flex-shrink-0">
                    <i className={`${item.icon} text-primary-400`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-background-100 text-sm whitespace-nowrap">{item.title}</h4>
                    <p className="text-xs text-foreground-400 mt-0.5">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="rounded-2xl overflow-hidden bg-foreground-900 border border-foreground-800/50">
              <div className="overflow-x-auto">
                <table className="w-full text-left">
                  <thead>
                    <tr className="border-b border-foreground-800/50">
                      <th className="px-5 py-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Category</th>
                      <th className="px-5 py-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Update Frequency</th>
                      <th className="px-5 py-4 text-xs font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Popularity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { name: "Streetwear Spreadsheet", freq: "Weekly", pop: 5 },
                      { name: "Sneaker Spreadsheet", freq: "Daily", pop: 5 },
                      { name: "Luxury Spreadsheet", freq: "Weekly", pop: 4 },
                      { name: "Budget Spreadsheet", freq: "Weekly", pop: 4 },
                      { name: "Jersey Spreadsheet", freq: "Weekly", pop: 4 },
                      { name: "Accessories Spreadsheet", freq: "Bi-weekly", pop: 4 },
                    ].map((row, i) => (
                      <tr key={row.name} className={`border-b border-foreground-800/30 ${i % 2 === 0 ? "bg-foreground-900/30" : ""} hover:bg-foreground-800/30 transition-colors`}>
                        <td className="px-5 py-3.5 text-sm font-medium text-background-100 whitespace-nowrap">{row.name}</td>
                        <td className="px-5 py-3.5 text-sm text-foreground-300 whitespace-nowrap">{row.freq}</td>
                        <td className="px-5 py-3.5">
                          <div className="flex items-center gap-0.5">
                            {Array.from({ length: 5 }).map((_, si) => (
                              <i
                                key={si}
                                className={`text-xs ${si < row.pop ? "ri-star-fill text-primary-400" : "ri-star-fill text-foreground-700"}`}
                              ></i>
                            ))}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}